import { styled } from 'libs/ui/styled';

const DEFAULT_MIN_WIDTH = 360;

export const GridStyled = styled('div', {
  shouldForwardProp: (prop) => prop !== 'columnCount' && prop !== 'minWidth',
})(({ minWidth = DEFAULT_MIN_WIDTH }: { minWidth?: number }) => ({
  display: 'grid',
  gridTemplateColumns: `repeat(auto-fill, minmax(${minWidth}px, 1fr))`,
  gap: '12px 16px',
}));
